// General purpose type to represent the current status of any network request
export const INITIAL = 'initial';
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const ERROR = 'error';
export const UPLOADED = 'uploaded';

export type RequestStatus = typeof INITIAL | typeof LOADING | typeof SUCCESS | typeof ERROR | typeof UPLOADED;
